import type { CreatePersonResponseType } from 'src/api/generated/touring/types';
import { useCreatePerson as useCreatePersonApi } from '@api';
import { AddPersonFormSchemaType, useNotification } from '@common';
import { AxiosError } from 'axios';

const TRANS_KEY = 'NOTIFICATIONS.ADD_PERSON';

type UseCreatePersonReturnType = {
  createPerson: (
    data: AddPersonFormSchemaType
  ) => Promise<CreatePersonResponseType>;
};

export const useCreatePerson = (): UseCreatePersonReturnType => {
  const { mutateAsync } = useCreatePersonApi();

  const { showSuccess, showError } = useNotification();

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const createPerson = async (
    data: AddPersonFormSchemaType
  ): Promise<CreatePersonResponseType> => {
    return mutateAsync(
      {
        data,
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { createPerson };
};
